import React from 'react'
import EledoButton, { EledoButtonProps } from './EledoButton'
import { useConfirmModal } from 'hooks'

export type EledoConfirmButtonProps = EledoButtonProps & {
  modalTitle: string,
  modalText: string
  modalConfirmText: string
  modalCancelText: string
  onSuccess: Function
  onFailure: Function
}
const EledoConfirmButton = (props: EledoConfirmButtonProps) => {
  const {
    modalTitle,
    modalText,
    modalConfirmText,
    modalCancelText,
    onSuccess,
    onFailure,
    ...buttonProps
  } = props;
  const {renderModal, showConfirmModal} = useConfirmModal(modalTitle, modalText, modalConfirmText, modalCancelText,
    () => onSuccess(), () => onFailure(), () => onFailure()
  )
  return (
    <>
      <EledoButton {...buttonProps} onClick={showConfirmModal}/>
      { renderModal() }
    </>
  )
}

export default EledoConfirmButton